(function () {
  'use strict';

  angular
    .module('specsguardApp')
    .controller('ModuleCtrl', ModuleCtrl);

  ModuleCtrl.$inject = ['$scope', 'moduleList', 'Module', 'errorMessageService', 'Labels'];

  function ModuleCtrl ($scope, moduleList, Module, errorMessageService, Labels) {

    $scope.isLoading = true;
    $scope.LABELS = Labels;

    $scope.list = moduleList;
    $scope.collapsible = {
      modules: true,
      submodules: true,
    };

    $scope.update = function (updatedModuleList) {
      $scope.list = updatedModuleList;
    };

    $scope.getType = (item, index) => {
      if (item.submodules) {
        return 'module';
      } else if (item.elements) {
        if (angular.isNumber(index)) {
          return `submodule_${index}`;
        } else {
          return 'submodule';
        }
      } else {
        return 'element';
      }
    };

    $scope.saveReorder = function (item, list) {
      if ($scope.getType(item) === 'module') {
        return Module.update(
          {id: item._id}, {module: {order: item.order}}).$promise;
      }

      if ($scope.getType(item) === 'submodule') {
        return Module.updateSubmodule(
          { submoduleId: item._id}, {submodule: {order: item.order}}).$promise;
      }

      if ($scope.getType(module) === 'element') {
        let elementIds = [];

        list.forEach((item) => {
          if (item.active) {
            elementIds.push(item._id);
          }
        });
        return Module.updateSubmodule(
          { submoduleId: item.submoduleId}, {submodule: {elementIds: elementIds}}).$promise;
      }
    };

    $scope.saveModuleDialogOptions = {
      title: 'Module',

      fields: [
        {
          key: 'name',
          label: Labels.getLabel('modulename'),
          required: true,
          type: 'text'
        },
        {
          key: 'protected',
          help: 'moduleprotected',
          label: Labels.getLabel('protected'),
          required: false,
          type: 'checkbox'
        }
      ],

      save: function (form, instance) {
        let request;
        if (instance) {
          request = Module.update({id: instance._id}, {module: form});
        } else {
          request = Module.save({module: form});
        }

        return request.$promise.then(function (newModuleList) {
          errorMessageService.showSuccess(Labels.getLabel('succesfullmodulechange'));
          $scope.list = newModuleList;
        })
          .catch(function () {
            errorMessageService.showError(Labels.getLabel('failuremodulechange'));
            return 'Fout tijdens aanmaken of bewerken van module';
          });
      }
    };
  }
})();
